import PropTypes from 'prop-types';
import { Form, Col } from 'antd';
import { Upload } from 'components';
import './Muestras.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const Muestras = ({ form }) => {
  return (
    <div className="hallazgos-imagenes">
      <Form form={form} layout="vertical">
        <span className="instruction-span" style={{ color: '#9159CB' }}>
          Captura de 2 a 5 muestras.
        </span>
        <div className="hallazgos-imagenes-row">
          <Col>
            <Form.Item
              name="muestra1"
              className="hallazgos-imagenes-muestra"
              rules={[{ required: true, message: fieldMsgs.ERR_SAMPLE_FIELD_REQUIRED }]}
              label="Muestra 1">
              <Upload disabled={false} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name="muestra2"
              className="hallazgos-imagenes-muestra"
              rules={[{ required: true, message: fieldMsgs.ERR_SAMPLE_FIELD_REQUIRED }]}
              label="Muestra 2">
              <Upload disabled={false} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="muestra3" label="Muestra 3" className="hallazgos-imagenes-muestra">
              <Upload disabled={false} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="muestra4" label="Muestra 4" className="hallazgos-imagenes-muestra">
              <Upload disabled={false} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="muestra5" label="Muestra 5" className="hallazgos-imagenes-muestra">
              <Upload disabled={false} />
            </Form.Item>
          </Col>
        </div>
      </Form>
    </div>
  );
};

Muestras.propTypes = {
  form: PropTypes.shape({}).isRequired
};

export default Muestras;
